var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.90197 0.849609L5.02441 3.72775L2.14686 0.849609L0.910538 2.08593L5.02441 6.19922L9.13829 2.08593L7.90197 0.849609Z"}));
}

ChevronDownInline.defaultProps = {"width":"10","height":"7","viewBox":"0 0 10 7"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
